import { create } from "zustand";
import { persist } from "zustand/middleware";

type ChatTourState = {
  hasSeentour: boolean;
  tourWasSeen: () => void;
  // for testing purposes
  resetTour: () => void;
};

export const useChatTourStore = create<ChatTourState>()(
  persist(
    (set) => ({
      hasSeentour: false,
      tourWasSeen: () => set({ hasSeentour: true }),
      resetTour: () => set({ hasSeentour: false }),
    }),
    {
      name: "chat-tour-preference",
    },
  ),
);
